import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "image-preview" };
const _hoisted_2 = {
    key: 0,
    class: "watermark"
};
const _hoisted_3 = { class: "calendar-preview mx-auto p-2" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "arrow-left" }, null, -1);
import '@fullcalendar/core/vdom'; // solves problem with Vite
import FullCalendar from '@fullcalendar/vue3';
import { useCalendarSettingsStore } from '../stores/calendarSettings';
import { useCalendarImagesStore } from '../stores/calendarImages';
import { useInitStore } from '../stores/init';
import ImageUpload from '../components/ImageUpload.vue';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BasicTemplate',
    setup(__props) {
        const calendarSettingsStore = useCalendarSettingsStore();
        const calendarImagesStore = useCalendarImagesStore();
        const initStore = useInitStore();
        const tooltipDismiss = ref(true);
        calendarSettingsStore.title.fontFace.fontName = 'Nunito';
        calendarSettingsStore.title.fontSize = 24;
        calendarSettingsStore.setDayNames('short');
        calendarSettingsStore.calendarOptions.titleFormat = { year: 'numeric', month: 'long' };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(ImageUpload, { imageIndex: 0 }),
                    (_unref(calendarImagesStore).imageSelected)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "CustomCalendarMaker.com"))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(FullCalendar), {
                        ref: "fullcalendar",
                        options: _unref(calendarSettingsStore).calendarOptions
                    }, null, 8, ["options"])
                ]),
                ((!tooltipDismiss.value))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "tooltip",
                        class: "d-none d-xxl-block",
                        onClick: _cache[0] || (_cache[0] = ($event) => ((tooltipDismiss.value = true)))
                    }, [
                        _hoisted_4,
                        _createTextVNode(" Use these buttons to swap the calendar month")
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
